import { InventoryProvider } from '@scaleaq/sitecontrol-lib';

import { SensorByProviderSelector } from '@/components/providerSensorConfig/SensorByProviderSelector.tsx';
import {
  WidgetConfigSiteTabbedShell,
  type InventorySiteSectionSource,
} from '@/components/widgetConfigSiteTabbedShell/index.ts';
import { WidgetConfigModalProps } from '@/types.ts';

export type ProviderSensorWidgetConfig = {
  id: string;
  name: string;
};

type ProviderSensorConfigProps = WidgetConfigModalProps & {
  provider: InventoryProvider;
  source: InventorySiteSectionSource;
};

export const ProviderSensorConfig = ({
  provider,
  source,
  widgetId,
  onSave,
  onClose,
  onGoBack,
  setModalTitle,
}: ProviderSensorConfigProps) => (
  <WidgetConfigSiteTabbedShell
    source={source}
    widgetId={widgetId}
    onSave={onSave}
    onClose={onClose}
    onGoBack={onGoBack}
    renderSitePanel={() => (
      <SensorByProviderSelector provider={provider} setModalTitle={setModalTitle} />
    )}
  />
);
